export default __webpack_public_path__ + "static/media/empties.558028ac.png";